const $ = jQuery.noConflict();

'use strict';
const CardKnox = {
	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function () {
		if ($('body.woocommerce-checkout').length > 0) {
			setTimeout(() => {
				CardKnox.inputStyling();
				/* this.catchCardknoxError(); */
				CardKnox.catchWooError();
			}, 1000);

            $(window).on('resize', function() {
                setTimeout(() => {
                    CardKnox.inputStyling();
                }, 100);
            });
		}
    },

    /* catchCardknoxError: ()=>{
        jQuery(document).ready(function($) {
            const bodyObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1 && $(node).is('.wc-cardknox-error')) {

							setTimeout(() => {
								CardKnox.inputStyling();
								CardKnox.closePopup();
							}, 1000);
                        }
                    });
                });
            });
            bodyObserver.observe(document.body, {childList: true, subtree: true});
        });
    }, */

    catchWooError: ()=>{
        jQuery(document).ready(function($) {
            $(document).ajaxComplete(function(event, xhr, settings) {
                if (settings.url.includes("wc-ajax=checkout")) {
                    let response;
                    try {
                        response = JSON.parse(xhr.responseText);
                    } catch (e) {
                        console.error("Failed to parse AJAX response:", e);
                        return;
                    }

                    if (response.result === 'failure') {
                        CardKnox.closePopup();
                        $('html, body').stop().animate({scrollTop: 0}, 1000);
                    }
                }
            });
        });
    },

    closePopup() {
        $('body').toggleClass('cart-overlay', false);
        $('.estimated-time__popup').toggleClass('estimated-time__popup--show', false);
    },

	inputStyling: function () {
		let style = {
            height: '50px',
			padding: '0 25px',
			backgroundColor: 'white',
			width: '100%',
			color: '#000',
			fontSize: '16px',
			outline: 'none',
			fontFamily: 'Hind, sans-serif',
			fontWeight: '500',
			boxSizing: 'border-box',
            boxShadow: 'inset 1px 3px 7px rgba(137, 137, 137, 0.16)',
            borderRadius: '5px',
            border: '1px solid #ababab'
		};

		setIfieldStyle('card-number', style);
		setIfieldStyle('cvv', style);
	}

};

export default CardKnox;
